/* eslint-disable no-unused-expressions */
import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import { Box, Card } from '@material-ui/core'
import Cancel from '@material-ui/icons/Cancel'
import Moment from 'react-moment'
import moment from 'moment'

import DateHelpers from '../../classes/DateHelpers'
import NotFound from '../NotFound'

import './DashboardComponent.scss'
import DashboardOnBoarding from './DashboardOnBoarding'
import SOVNetworksHeader from './SOVNetworksHeader'
import SOVNetworks from './SOVNetworks'
import ContentRankTable from './ContentRankTable'

export default class DashboardComponent extends React.Component {
static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    homepage: PropTypes.object,
    history: PropTypes.object,
    classes: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    sovNetworks: PropTypes.object,
    sovContentRank: PropTypes.object,
    sovContentRankByScore: PropTypes.object,
    selectedCategory: PropTypes.string,
    setSelectedCategory: PropTypes.func,
    selectedMetricDate: PropTypes.string,
    setSelectedMetricDate: PropTypes.func,
    fetchSOVNetworks: PropTypes.func,
    fetchSOVCotentRank: PropTypes.func,
    fetchSOVCotentRankByScore: PropTypes.func,
    contentRankDate: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      screenWidth: window.innerWidth,
      dateArray: [],
      selectedNetwork: [],
      dateIndex: 0
    }

    this.scrollRef = React.createRef()
  }

  componentDidMount () {
    if (this.props.sovNetworks && this.props.sovNetworks.details && this.props.sovNetworks.details.length > 0) {
      this.setDateArary()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.sovNetworks != this.props.sovNetworks && this.props.sovNetworks && this.props.sovNetworks.details && this.props.sovNetworks.details.length > 0) {
      this.setDateArary()
    }
  }

  setDateArary = () => {
    const metrics = this.props.sovNetworks.details[0].metrics
    const startDate = metrics[0].date
    const endDate = metrics[metrics.length - 1].date
    const dates = DateHelpers.getDateArry(startDate, endDate)
    const date = this.props.contentRankDate && moment(this.props.contentRankDate).format('MM/DD/YYYY')
    this.setState({ dateArray: dates, dateIndex: dates.indexOf(date) >= 0 ? dates.indexOf(date) : dates.length - 1 })
  }

  setSelectedNetwork = (selectedNetwork) => {
    this.setState({ selectedNetwork: selectedNetwork })
  }

  setDateIndex = (index) => {
    this.setState ({ dateIndex: index })
    const date = moment(this.state.dateArray[index]).format('YYYY-MM-DD')
    this.props.fetchSOVCotentRank(this.props.selectedCategory, date, true)
    this.props.fetchSOVCotentRankByScore(this.props.selectedCategory, date, false)
    this.props.setSelectedMetricDate(date)
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics of Share of Conversation will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }
    return (
      <DashboardOnBoarding
        run={true}
        setScroll={this._setScroll.bind(this)}
        category={this.props.selectedCategory}
        />
    )
  }

  _setScroll () {
    window.scrollTo({
      top: this.scrollRef.current.offsetTop + 200
    })
  }

  render () {
    if (this.props.homepage.error || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.sov_networks && this.props.homepage.details.sov_networks.length === 0)) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    return (
      <div className="rightSide dashboardComponent" ref={this.scrollRef}>
        <Container fluid={true}>
          {this._renderShortcut()}
          {this._renderOnboarding ()}
          <Row className="header calendarHeader">
            <Col>
              <SOVNetworksHeader
                homepage={this.props.homepage}
                history={this.props.history}
                shortcut={this.props.shortcut}
                selectedCategory={this.props.selectedCategory}
                setSelectedCategory={this.props.setSelectedCategory}
                fetchSOVNetworks={this.props.fetchSOVNetworks}
                fetchSOVCotentRank={this.props.fetchSOVCotentRank}
                fetchSOVCotentRankByScore={this.props.fetchSOVCotentRankByScore}
                setSelectedMetricDate={this.props.setSelectedMetricDate}
              />
            </Col>
          </Row>
          <Card className='wrapperCard'>
            <Row>
              <Col xl={8}>
                <SOVNetworks
                  sovNetworks={this.props.sovNetworks}
                  selectedCategory={this.props.selectedCategory}
                  setSelectedNetwork={this.setSelectedNetwork}
                  setSelectedMetricDate={this.props.setSelectedMetricDate}
                  dateArray={this.state.dateArray}
                  dateIndex={this.state.dateIndex}
                  setDateIndex={this.setDateIndex}
                />
              </Col>
              <Col xl={4}>
                <Box className='tableWrap' id='contentRank'>
                  <ContentRankTable
                    classes={this.props.classes}
                    sovContentRank={this.props.sovContentRank}
                    sovContentRankByScore={this.props.sovContentRankByScore}
                    selectedCategory={this.props.selectedCategory}
                    selectedNetwork={this.state.selectedNetwork}
                    dateArray={this.state.dateArray}
                    dateIndex={this.state.dateIndex}
                />
                </Box>
              </Col>
            </Row>
          </Card>
        </Container>
      </div>
    )
  }
}